export interface IConcurrencyType {
  /** Тип **/
  type: EConcurrencyType;
  /** Название **/
  name: string;
  /** Активная вкладка **/
  isActive: boolean;
}

export enum EConcurrencyType {
  /** Конкуренция в регионе **/
  Region = 'region',
  /** Локальная конкуренция **/
  Local = 'local',
  /** Конкуренция по соседству **/
  NearBy = 'nearBy',
}
